// Wallet constants and utilities

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ============================================
// Multi-Platform Mini App Support (Telegram & MAX)
// ============================================

// Telegram WebApp instance
export const tg = window.Telegram?.WebApp;

// MAX WebApp instance (MAX messenger uses window.WebApp)
export const maxApp = window.WebApp && !window.Telegram ? window.WebApp : null;

// Unified platform detection
export const getPlatform = () => {
  if (tg) return 'telegram';
  if (maxApp) return 'max';
  return 'web';
};

export const platform = getPlatform();
export const isTelegram = platform === 'telegram';
export const isMax = platform === 'max';
export const isMiniApp = isTelegram || isMax;

// Get unified WebApp instance
export const webApp = tg || maxApp;

// Initialize Mini App (Telegram or MAX)
if (tg) {
  tg.ready();
  tg.expand();
  console.log('Telegram WebApp initialized:', {
    platform: 'telegram',
    initData: tg.initData,
    user: tg.initDataUnsafe?.user
  });
} else if (maxApp) {
  // MAX WebApp initialization
  if (typeof maxApp.ready === 'function') {
    maxApp.ready();
  }
  if (typeof maxApp.expand === 'function') {
    maxApp.expand();
  }
  console.log('MAX WebApp initialized:', {
    platform: 'max',
    initData: maxApp.initData,
    user: maxApp.initDataUnsafe?.user
  });
}

// Get user data from any Mini App platform
export const getMiniAppUser = () => {
  if (tg) {
    return tg.initDataUnsafe?.user;
  }
  if (maxApp) {
    return maxApp.initDataUnsafe?.user || maxApp.user;
  }
  return null;
};

// Helper function to open external links (works in Telegram and MAX Mini Apps)
export const openExternalLink = (url) => {
  // Try Telegram
  if (tg) {
    try {
      if (typeof tg.openLink === 'function') {
        tg.openLink(url, { try_instant_view: false });
        return;
      }
    } catch (e) {
      console.error('Telegram openLink error:', e);
    }
  }
  
  // Try MAX
  if (maxApp) {
    try {
      if (typeof maxApp.openLink === 'function') {
        maxApp.openLink(url);
        return;
      }
    } catch (e) {
      console.error('MAX openLink error:', e);
    }
  }
  
  // Fallback: try to use window.open
  try {
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
      newWindow.focus();
      return;
    }
  } catch (e) {
    console.error('window.open error:', e);
  }
  
  // Last resort: redirect current page
  window.location.href = url;
};

// Haptic feedback (works in both Telegram and MAX)
export const hapticFeedback = (type = 'light') => {
  try {
    if (tg?.HapticFeedback) {
      tg.HapticFeedback.impactOccurred(type);
    } else if (maxApp?.impactOccurred) {
      maxApp.impactOccurred(type);
    }
  } catch (e) {
    console.log('Haptic feedback not available');
  }
};

// Close Mini App
export const closeMiniApp = () => {
  if (tg?.close) {
    tg.close();
  } else if (maxApp?.close) {
    maxApp.close();
  }
};

// ============================================
// UI Constants
// ============================================

// Color palette
export const SBER = {
  green: '#21A038',
  greenDark: '#1A8B2D',
  greenLight: '#2BB24A',
  greenPale: '#E8F5E9',
  greenMuted: '#C8E6C9',
  gray: '#6B7280',
  grayLight: '#9CA3AF',
  grayPale: '#F3F4F6',
  dark: '#1F2937',
  white: '#FFFFFF',
  bg: '#F5F5F5',
  bgLight: '#F9FAFB',
  text: '#1F2937'
};

// Animation variants
export const pageVariants = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.25, ease: "easeOut" } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.15 } }
};

export const tapAnimation = { scale: 0.97 };

// Bank details for payments
export const BANK_DETAILS = {
  USD: {
    bank: 'Optima Bank',
    account: '1091620019379314',
    bik: '109016',
    recipient: 'ОсОО «ФВА Финанс»',
    inn: '01111201510129'
  },
  KGS: {
    bank: 'Optima Bank', 
    account: '1091020019379317',
    bik: '109016',
    recipient: 'ОсОО «ФВА Финанс»',
    inn: '01111201510129'
  }
};
